import Vue from 'vue';
import { ApiService } from '@/services/api.service'
import { Log } from '@/services/log.service'

import Kombi from '@/models/Kombi'
import Variante from '@/models/Variante'
import Komponente from '@/models/Komponente'

import { KombiRepository } from '@/repositories/KombiRepository'
import { KomponentenRepository } from '@/repositories/KomponentenRepository'

import { store } from '@/store'
import { mapState } from 'vuex'
import { stateMerge } from 'vue-object-merge'

export const Factory = new Vue({
	store,

	computed: {
		...mapState(['settings', 'presets']),
		...mapState('configurator', ['configurator', 'intro']),
	},

	methods: {

		/**
		 * 	Parsed und normalisiert die rohen Daten aus dem JSON.
		 *	Fügt Daten in Repositories ein.
		 *
		 */
		parseConfiguratorData ( rawData ) {

			//Log.INFO( 'FactoryService', 'parseConfiguratorData()', rawData );

			// -------------------------------
			// Allgemeine Daten direkt commiten

			this.$store.commit('LL/SET', rawData.LL);
			this.$store.commit('configurator/SET_SELECTS', rawData.selects);
			this.$store.commit('configurator/SET_INTRO', rawData.intro);

			// -------------------------------
			// Komponenten parsen

			for (var typ in rawData.komponenten) {
				var storage = new Komponente( rawData.komponenten[typ][key] );
				for (var key in rawData.komponenten[typ]) {
					var variantenModel = new Variante( rawData.komponenten[typ][key] );
					storage.add( key, variantenModel );			
				}
				KomponentenRepository.add( typ, storage );
			}

			// --------------------------------
			// Kombis mutieren

			rawData.kombis = this.explodeKombis( rawData.kombis );
			//Log.INFO( 'FactoryService', 'parseConfiguratorData()', rawData.kombis );

			// --------------------------------
			// Kombis parsen

			rawData.kombis.forEach((item) => {
				
				for (var key in item) {

					var ref = item[key];
					if (typeof ref == 'string') ref = {typ:ref};

					if (key != 'override') {
						var componentData = KomponentenRepository.find( key, ref );
						
						if (!componentData) {
							Log.ERROR( 'FactoryService', 'parseConfiguratorData()', `data.komponenten.${key} unbekannt!` );
						}

						// Farben parsen
						if (ref.farben) {
							ref.farben.forEach((farbe, n) => {
								var colorData = KomponentenRepository.find( 'farbe', farbe.typ );
								if (!colorData) {
									Log.ERROR( 'FactoryService', 'parseConfiguratorData()', `data.komponenten.farbe.${n} unbekannt!` );
								}
								ref.farben[n] = Object.assign({key:'farben'}, colorData, farbe);
							});
						}

						item[key] = Object.assign({key:key}, componentData, ref);
					}
				}

				// per '.override' im JSON können bestimmte Daten überschrieben werden.
				if (item.override) {
					var override = Object.assign({}, item.override);
					delete( item.override );
					stateMerge(item, override);
				}

				var kombiModel = new Kombi( item );
				KombiRepository.add( kombiModel );

			});

			return {
				kombis: KombiRepository.findAll(),
				komponenten: KomponentenRepository.findAll(),
			}
		},

		/**
		 * 	Array-Schreibweise der Kombis in einzelne Kombis umwandeln.
		 * 	Erzeugt ein Array an "Mutationen", falls bei einer Property ein Array angegeben wurden.
		 * 
		 * 	{kopf: ['standard','snu','pickel','crc'], ...} 
		 * 			=> [{kopf:'standard',...}, {kopf:'snu',...}, ...]
		 * 	{kopf: [{typ:'standard'}, {typ:'snu'}, {typ:'pickel'}, {typ:'crc'}], ...}
		 * 			=> [{kopf:{typ:'standard'}, ...}, {kopf:{typ:'snu'}, ...}, ...]
		 */
		explodeKombis( kombis ) {
			var explodedKombis = [];
			for (var i in kombis) {
				var obj = kombis[i];

				var mutationField = this.getMutationFieldName( obj );

				if (mutationField) {
					for (var m in obj[mutationField]) {
						var mutant = Object.assign({}, obj);
						mutant[mutationField] = obj[mutationField][m];

						// Rekursion für weitere Untervarianten
						var subMutationField = this.getMutationFieldName( mutant );
						if (subMutationField) {
							explodedKombis = explodedKombis.concat( this.explodeKombis([mutant]) );
						} else {
							explodedKombis.push( Object.assign({}, mutant) );
						}
					}
				} else {
					explodedKombis.push( obj );
				}
			}
			return explodedKombis;
		},

		/**
		 * 	Gibt zurück, ob das Object ein Feld hat, das
		 * 	zu Mutationen verwendet werden soll.
		 */
		getMutationFieldName ( obj ) {
			var mutationField = false;
			for (var n in obj) {
				if (Array.isArray(obj[n])) {
					return n;
				}
			}
			return false;
		}

	}
});



// WEBPACK FOOTER //
// ./src/services/factory.service.js